module.exports = "//img1.rrcimg.com/_next/static/src/assets/cc_3y1gA.png";